import { StyleProp, StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';
import { ShadowedView } from 'react-native-fast-shadow';
import { mvs } from 'react-native-size-matters';

import { CustomIcon, CustomIconProps } from './CustomIcon';
import { isTablet } from '../constants';
import { useShadowStyles } from '../hooks/useShadowStyles';

interface Props {
  icon?: CustomIconProps['name'];
  iconSize?: CustomIconProps['size'];
  iconColor?: CustomIconProps['color'];
  onPress?: () => void;
  containerStyle?: StyleProp<ViewStyle>;
  buttonStyle?: StyleProp<ViewStyle>;
  hidden?: boolean;
  disabled?: boolean;
}

export const FloatingExitButton = (props: Props) => {
  const shadowStyles = useShadowStyles();

  if (props.hidden) {
    return null;
  }

  return (
    <ShadowedView style={[styles.container, props.containerStyle]}>
      <TouchableOpacity
        onPress={props.onPress}
        hitSlop={{ top: 5, bottom: 5, left: 5, right: 5 }}
        disabled={props.disabled}
      >
        <View style={[styles.button, props.buttonStyle, shadowStyles]}>
          <CustomIcon
            name={props.icon ?? 'close'}
            size={props.iconSize ?? 24}
            color={props.iconColor ?? '#474747'}
          />
        </View>
      </TouchableOpacity>
    </ShadowedView>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: isTablet ? mvs(22) : 24,
    top: 24,
  },
  button: {
    backgroundColor: '#fff',
    width: 46,
    height: 46,
    borderRadius: 23,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
